// @flow
import Component from './component'
export default () => ({
  path: 'account-statements-view',
  element: <Component />,
})
